const booking = {
  booking: {
    title: 'Complete Reservation',
    property: 'Property',
    unit: 'Unit',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Guests',
    nightsLabel: 'Nights',
    nightSingular: 'night',
    nightPlural: 'nights',
    guestSingular: 'guest',
    guestPlural: 'guests',
    serviceFee: 'Service fee',
    taxes: 'Taxes',
    discount: 'Discount',
    total: 'Total',
    installments: 'Up to 12 installments on card',
    staySummary: 'Stay summary',
    priceBreakdown: 'Price breakdown',
    guestInfo: 'Guest Information',
    guestName: 'Full name',
    guestEmail: 'Email',
    guestPhone: 'Phone / WhatsApp',
    guestPhoneLabel: 'Phone',
    payment: 'Payment',
    paymentDetails: 'Payment details',
    payAmount: 'Pay {{amount}}',
    payNow: 'Pay with Card',
    processing: 'Processing...',
    processingPayment: 'Processing payment...',
    preparingPayment: 'Preparing payment...',
    continueToPayment: 'Continue to payment',
    fillAllFields: 'Fill in all guest details to continue',
    securePayment: 'Secure payment via Stripe',
    secureReservation: 'Secure reservation via Reserve Connect',
    backToReview: 'Back to review',
    backToProperty: 'Back to property',
    backToSearch: 'Back to search',
    preparingReservation: 'Preparing your reservation...',
    cannotProceed: 'Could not proceed',
    incompleteInfo: 'Incomplete reservation information.',
    cannotCreateIntent: 'Could not create reservation intent.',
    errorCreatingIntent: 'Error creating reservation intent.',
    paymentCancelled: 'Payment cancelled by user.',
    paymentError: 'Error processing payment.',
    paymentErrorDefault: 'An error occurred while processing payment. Please try again.',
    bookingStatus: 'Booking status',
    checkingStatus: 'Checking booking status...',
    statusPending: 'Awaiting confirmation',
    statusConfirmed: 'Confirmed',
    statusCheckin: 'Check-in pending',
    statusCheckedIn: 'Checked in',
    statusCheckedOut: 'Checked out',
    statusCancelled: 'Cancelled',
    statusNoShow: 'No show',
    statusCompleted: 'Completed',
    statusProcessing: 'Processing...',
    hostBookingId: 'Booking ID',
    hostCommitPendingDesc: 'The property is being notified of your reservation.',
    paymentNotCompleted: 'Payment not completed',
    paymentNotApproved: 'Payment was not approved. Please check your details and try again.',
    processingTimeout: 'Processing time expired. Please contact support.',
    cannotConfirmPayment: 'Could not confirm payment. Please try again.',
    paymentSystemUnavailable: 'Payment system temporarily unavailable.',
    cannotStartPayment: 'Could not start payment.',
    errorStartingPayment: 'Error starting payment.',
    incompletePaymentInfo: 'Incomplete payment information.',
    timeExpired: 'Time expired',
    timeExpiredDesc: 'The time to confirm this reservation has expired. Please search again.',
    redoSearch: 'Search again',
    hurry: 'Hurry! ',
    reservationExpiresIn: 'Reservation expires in',
    minuteSingular: 'minute',
    minutePlural: 'minutes',
    secondSingular: 'second',
    secondPlural: 'seconds',
    confirmed: 'Booking Confirmed!',
    confirmedTitle: 'Booking confirmed',
    confirmedSuccess: 'Your reservation has been confirmed successfully.',
    confirmationEmailSent: 'We have sent the details to {{email}}',
    confirmationSent: 'We sent the confirmation to your email.',
    confirmationCode: 'Confirmation code',
    reservationDetails: 'Reservation details',
    totalPaid: 'Total paid',
    detailsEmailed: 'Details sent by email',
    backToHome: 'Back to home',
    cancelPolicy: 'Cancellation Policy',
    errorPayment: 'Error processing payment. Please try again.',
    pageTitle: 'Complete Reservation - Reserve Connect',
    pageDescription: 'Complete your reservation on Reserve Connect. Real prices and confirmed availability.',
    confirmationPageTitle: 'Reservation confirmed - Reserve Connect',
    confirmationPageDesc: 'Your reservation has been successfully confirmed on Reserve Connect.',

    // Payment method selection
    choosePaymentMethod: 'Choose payment method',
    cardPayment: 'Credit Card',
    cardPaymentDesc: 'Secure payment via Stripe',
    pixPayment: 'PIX',
    pixPaymentDesc: 'Instant payment via Mercado Pago',
    installmentsPayment: 'Installments',
    installmentsPaymentDesc: 'Pay in up to 12 installments',
    chooseInstallments: 'Choose number of installments',
    installmentsLabel: 'Installments',
    installmentsTotal: 'Total: {{total}}',
    installmentsNoInterest: 'No interest',
    selectInstallments: 'Select number of installments',
    payInstallment: 'Pay {{count}}x of {{value}}',

    // PIX
    pixInstructions: 'Scan the QR code below with your banking app to pay via PIX.',
    pixCopyPaste: 'Or copy and paste the PIX code:',
    pixWaitingPayment: 'Waiting for payment...',
    pixConfirmed: 'Payment confirmed',
    pixGenerationError: 'Error generating PIX QR code. Please try again.',
    errorStartingPix: 'Error starting PIX payment.',
    pixExpiresIn: 'Expires at {{time}}',
    paymentMethod: 'Payment method',
    copy: 'Copy',
    installmentsInfo: 'Up to 12 installments on card',

    // Add-ons
    addOns: 'Add-ons',
    addOnsSubtitle: 'Personalize your stay with extra services',
    addOnsTotal: 'Add-ons',
    addOnsNone: 'No add-ons selected',
    addOnsPricePerBooking: 'Per booking',
    addOnsPricePerNight: 'Per night',
    addOnsPricePerPerson: 'Per person',
    addOnsContinue: 'Continue to payment',
    addOnsSkip: 'Skip, I only want accommodation',

    // Cancellation keys
    cancelReservation: 'Cancel Reservation',
    cancelReservationTitle: 'Cancel reservation',
    cancelConfirmTitle: 'Are you sure you want to cancel?',
    cancelConfirmDesc: 'The refund will be calculated according to the property\'s cancellation policy.',
    cancelRefundPreview: 'You will receive {{amount}} refund',
    cancelRefundFull: 'Full refund',
    cancelRefundPartial50: '50% refund',
    cancelRefundNone: 'No refund for this date',
    cancelRefundCdc: 'Full refund (Brazilian Consumer Code)',
    cancelProcessing: 'Processing cancellation...',
    cancelSuccess: 'Reservation cancelled successfully',
    cancelSuccessDesc: 'Your cancellation has been processed. The refund will be credited within 10 business days.',
    cancelError: 'Could not cancel the reservation',
    cancelErrorDesc: 'Please try again or contact our Reservations Center.',
    cancelAlreadyCancelled: 'This reservation has already been cancelled.',
    cancelNotCancellable: 'This reservation can no longer be cancelled.',
    cancelDaysUntilCheckin: '{{days}} day(s) until check-in',
    cancelPolicyApplied: 'Policy applied: {{policy}}',
    cancelReason: 'Cancellation reason (optional)',
    cancelReasonPlaceholder: 'Describe the reason for cancellation...',
    cancelSubmit: 'Confirm cancellation',
    cancelBack: 'Go back',

    addToCalendar: 'Add to Calendar',
    addToCalendarHint: 'Download an .ics file for Google Calendar, Apple Calendar, or Outlook',
  },
};
export default booking;
